<template>
  <!--笔试选择集合页第2版 （备份）  准备停用-->
  <div id="jsbs">
    <!--引用公共头部-->
    <top-head :pageName="pageName"></top-head>
    <header style="display: none"><!--隐藏阶段选择按钮-->
      <h1><router-link :to="{name: 'StudyAim'}">{{resSubject}}</router-link></h1>
    </header>
    <!--<jszg-banner :selectPeriodNum="selectPeriodNum" :period="period"></jszg-banner>-->
    <div class="jszg2-banner" v-if="bannerData[0]">
      <a  @click="jumpUrl(bannerData[0].class_id, bannerData[0].jump_type, bannerData[0].signup)">
        <img :src="bannerData[0].image">
      </a>
    </div>
    <!--<div class="banner swiper-container">-->
      <!--<div class="swiper-wrapper">-->
        <!--<div class="swiper-slide" v-for="(item, index) in bannerData" :key="index"><a @click="jumpUrl(item.link_url, item.jump_type, item.signup)" ><img :src="item.image" width="100%" :alt="item.link_url"></a></div>-->
      <!--</div>-->
    <!--</div>-->
    <div class="nav1">
      <a @click="selectPeriod(1)" :class="{active: selectPeriodNum === 1}">笔试</a>
      <a @click="selectPeriod(2)" :class="{active: selectPeriodNum === 2}">面试</a>
      <a @click="selectPeriod(3)" :class="{active: selectPeriodNum === 3}">教师招聘</a>
    </div>
    <div id="navout">
      <div id="nav2" class="nav2" :class="{fixed: searchBarFixed}">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in periodData" :key="index">
              <!--<a @click="scrollto(index, item.id)" :class="{active: period === item.id}">{{item.name}}</a>-->
              <a v-scroll-to="'#degree' + (index === 0 ? 1 : index)" @click="scrollto(item.id)" :class="{active: period === item.id}">{{item.name}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav2" style="display: none">
      <a v-for="(item, index) in periodData" :key="index">{{item.name}}</a>
    </div>
    <!--通用中、小、幼-->
    <div class="degree" v-for="(item, index) in course1Data" :key="index">
      <div class="lightening" :id="'degree' + index"></div>
      <h2>{{item.title}}<span class="sub">{{item.label}}</span></h2>
      <div class="course1" v-for="(item2, index2) in item.content" :key="index2" @click="jumpUrl(item2.class_id, item2.jump_type, item2.signup)">
        <div class="left">
          <img :src="item2.class_app_img_1"  alt="">
        </div>
        <div class="right">
          <h4>{{item2.class_name}}</h4>
          <p class="detail">{{item2.class_name_main}}</p>
          <div v-if="item2.class_label">
            <span v-for="(item3, index3) in item2.class_label_details" :key="index3" :style="{'border-color': item3.label_bg_color ? item3.label_bg_color : '#000', 'color': item3.label_color ? item3.label_color : '#000'}" v-if="item3">
              {{item3.label_name}}
            </span>
          </div>
          <p class="people">{{item2.class_sum_price}}人报名</p>
          <b class="price" v-if="parseInt(item2.section_price + item2.section_price_decimal) === 0">0元</b>
          <b class="price" v-else>¥<span>{{item2.section_price}}</span>{{item2.section_price_decimal}}</b>
          <a class="bmst" v-if="item2.signup">去听课</a>
          <a class="bmst" v-else>查看课程</a>
        </div>
      </div>
      <div class="ad" v-if="item.advertisement[0]">
        <a :href="item4.href_url" v-for="(item4, index4) in item.advertisement" :key="index4">
          <img :src="item4.image" alt="item4.title">
        </a>
      </div>
    </div>
    <div id="free-listen">
      <h2>
        试听课程
        <span class="subtitle">
            好课试听试学
          </span>
      </h2>
      <div class="top">
        <a @click="jumpUrl(item.class_id, item.jump_type, item.signup)" v-for="(item, index) in freeListenData" :key="index" v-if="freeIndex === index"><img :src="item.class_app_img_2" :alt="item.title"></a>
      </div>
      <div class="bottom">
        <span :class="freeIndex === index ? 'active' : ''" v-on:click="changeListen" v-for="(item, index) in freeListenData" :key="index">{{item.class_name}}</span>
      </div>
    </div>
    <class-foot :selectPeriodNum="selectPeriodNum"></class-foot>
    <div class="reachbottom">-- 已经到底啦!!! --</div>
    <!--底部占位-->
    <div id="fix-bottom-void"></div>
    <bottom-bar :index="1"></bottom-bar>
  </div>
</template>

<script>
import Vue from 'vue'
import BottomBar from '../share/fixed/BottomBar'
import topHead from '../share/header/topHead'
import Swiper from 'swiper'
import VueScrollTo from 'vue-scrollto'
import classFoot from '../share/footer/classFoot'
import jszgBanner from '../share/plug/jszgBanner'
let options = {
  container: 'body', // 滚动的容器
  duration: 500, // 滚动时间
  easing: 'ease', // 缓动类型
  offset: 0, // 滚动时应应用的偏移量。此选项接受回调函数
  force: true, // 是否应执行滚动
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
  bannerSwiperOb: null
}

Vue.use(VueScrollTo, options)

export default {
  name: 'Jszg',
  components: {
    BottomBar,
    classFoot,
    topHead,
    jszgBanner
  },
  data () {
    return {
      pageName: 'Jszg',
      subject: 1, // 默认值：笔试
      period: 0, // 默认值：全部
      bannerData: {},
      course1Data: {},
      adData: {},
      freeListenData: {},
      freeIndex: 0,
      selectPeriodNum: 1, // 考试目标 1 笔试 、 2 面试、3 教师招聘
      periodData: {}, // 获得学段选择信息
      nav2SwiperOb: {},
      searchBarFixed: false,
      nav2Position: 0, // 定义导航固定位置
      initialState: true // 是不是第一次加载，即初始化
    }
  },
  computed: {
    resSubject: function () {
      let result = ''
      switch (this.$store.state.subject) {
        case 1:
          result = '教师资格-笔试'
          break
        case 2:
          result = '教师资格-面试'
          break
        case 3:
          result = '教师招聘-笔试'
          break
        case 4:
          result = '教师招聘-面试'
          break
        case 0:
        default:
          result = '教师资格-笔试'
          break
      }
      switch (this.$store.state.period) {
        case 1:
          result += '-' + '中学'
          break
        case 2:
          result += '-' + '小学'
          break
        case 3:
          result += '-' + '幼儿'
          break
        case 0:
        default:
          result += '-' + '小学'
          break
      }
      return result
    }
  },
  methods: {
    changeListen (event) {
      let _this = this
      let _el = event.target
      let nodeList = event.target.parentNode.children
      let targetIndex = _this.tabIndex(_el, nodeList)
      this.freeIndex = targetIndex
    },
    /**
     * @param target 事件触发的元素
     * @param nodeList 元素集合
     * @returns {number} 返回事件触发元素的下标
     */
    tabIndex (target, nodeList) {
      for (let i = 0; i < nodeList.length; i++) {
        if (target === nodeList[i]) {
          return i
        }
      }
    },
    // 获得 banner
    getBanner () {
      let data = {
        subject: this.selectPeriodNum,
        period: this.period,
        page: 1
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v2/get_live_course_one',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log('banner:')
          console.log(res)
          this.bannerData = res.data.data
          // this.$nextTick(() => { // 下一帧渲染
          //   this.bannerSwiper()
          // })
        })
        .catch(err => { console.log(err) })
    },
    // 获得课程一数据
    getCourse1 () {
      let data = {
        subject: this.subject,
        period: this.period
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v2/get_live_courses_sideways',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log('课程列表：')
          console.log(res)
          this.course1Data = res.data.data
        })
        .catch(err => { console.log(err) })
    },
    // 获得学段信息
    getPeriods () {
      let data = {
        subject: this.selectPeriodNum
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_courses_type',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          this.periodData = res.data.data
          this.$nextTick(() => { // 下一帧渲染
            this.nav2Swiper()
            this.setSwiperInit()
          })
        })
        .catch(err => { console.log(err) })
    },
    // 获得广告条数据
    getAd () {
      let data = {
        type: 2,
        subject: this.subject,
        period: this.period
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v2/get_live_course_advertisement',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          this.adData = res.data.data
        })
        .catch(err => { console.log(err) })
    },
    // 获得免费试听
    getFreeListen () {
      let data = {
        subject: this.$store.state.subject,
        period: this.$store.state.period,
        page: 4
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_course_free',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          this.freeListenData = res.data.data
        })
        .catch(err => { console.log(err) })
    },
    jumpUrl (classId, jumpType, signUp) {
      switch (jumpType) {
        case 0: // 0 不跳转
          event.preventDefault()
          break
        case 1: // 1 h5连接[资讯]
          this.$router.push(classId)
          break
        case 2: // 2 课程列表【合集id】 暂时用不到
          if (signUp) {
            this.$router.push({name: 'VideoPlay', query: {class_id: classId}})
          } else {
            this.$router.push({name: 'ClassDetailTeacher', query: {class_id: classId}})
          }
          break
        case 3: // 3 班级详情【班级id】
          if (signUp) {
            this.$router.push({name: 'VideoPlay', query: {class_id: classId}})
          } else {
            this.$router.push({name: 'ClassDetailTeacher', query: {class_id: classId}})
          }
          break
        case 4: // 4 h5连接[活动]
          this.$router.push(classId)
          break
        case 11:
          this.easyChat()
          break
      }
    },
    // 第一次导航选择：笔试、面试、教招；默认笔试
    selectPeriod (Num) {
      if (this.$route.query.active) {
        this.$store.dispatch('alterActiveData', this.$route.query.active ? this.$route.query.active : 1)
      }
      // 第一次加载的时候执行
      if (this.initialState) {
        if (this.$route.query.ms) {
          Num = 2
        } else if (!Num) {
          Num = 1
        }
        // 关闭第一加载初化状态
        this.initialState = false
      }
      this.$store.dispatch('alterTempData', {periodNumber: Num})
      this.selectPeriodNum = Num
      this.subject = Num
      this.period = 0
      this.getPeriods()
      this.getCourse1()
      this.getBanner()
    },
    nav2Swiper () {
      this.nav2SwiperOb = new Swiper('#nav2 .swiper-container', {
        initialSlide: 0,
        slidesPerView: 5,
        // spaceBetween: '4.27%',
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        slideShadows: true
      })
    },
    setSwiperInit () {
      setTimeout(() => {
        document.getElementsByClassName('swiper-wrapper')[0].style.transform = 'translate3d(0px, 0px, 0px)'
      }, 50)
    },
    // 选择2组科目
    selectPeriod2 (periodId) {
      this.period = periodId
      this.getCourse1()
    },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (this.nav2Position === 0) this.nav2Position = document.querySelector('#nav2').offsetTop
      if (scrollTop >= this.nav2Position) {
        this.searchBarFixed = true
      } else {
        this.searchBarFixed = false
      }
    },
    scrollto (periodId) {
      this.period = periodId
    },
    // 删除
    bannerSwiper () {
      this.bannerSwiperOb = new Swiper('.banner.swiper-container', {
        // effect: 'coverflow',
        speed: 2000,
        autoplay: {
          autoplay: true,
          delay: 1000
        },
        loop: true,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true // 修改swiper的父元素时，自动初始化swiper
      })
    },
    easyChat () {
      this.$easyliao(12523, 20523)
      return false
    }
  },
  mounted () {
    // this.getPeriods()
    // this.getCourse1()
    // this.getBanner()
    this.selectPeriod(this.$store.state.tempdata.periodNumber) // 存储返回时的位置：笔试、面试、教招
    this.getAd()
    this.getFreeListen()
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="stylus">
  #jsbs
    >>> #tophead
      padding: 0 .2rem
    header
      width: 100%
      height: .74rem
      margin: .3rem auto 0
      h1
        font-size: .4rem
        color: #050505
        font-weight: bold
        text-align: center
        &::after
          content: ""
          position: relative
          top: -.1rem
          right: -.2rem
          display: inline-block
          width: 0
          height: 0
          border-top: .16rem solid #3F3F3F
          border-left: .12rem solid transparent
          border-right: .12rem solid transparent
    .nav1
      height: .98rem
      line-height: .98rem
      border-bottom: .02rem solid #E5E5E5
      background-color: #fff
      a
        position: relative
        display: inline-block
        margin-left: .64rem
        font-size: .36rem
        color: #3D3C45
        font-weight: bold
        text-align: center
        &.active
          color: #FF7052
          &::after
            content: ""
            position: absolute
            left: 50%
            bottom: -.02rem
            display: block
            width: .48rem
            height: .08rem
            background-color: #FF7052
            margin-left: -.24rem
    .nav2
      position: static
      height: 1.18rem
      line-height: 1.18rem
      .swiper-slide
        width: auto!important
      a
        display: inline-block
        margin-left: .6rem
        font-size: .32rem
        color: #5E5E5E
        text-align: center;
        &:first-child
          margin-left: .2rem
          width: 1.5rem;
        &.active
          color: #FF7052
      &.fixed
        position: fixed
        top: 0
        left: 0
        z-index: 999
        width: 100%
        background-color: #fff
    #navout
      height: 1.18rem
    .degree
      position: relative
      padding: 0 .2rem .1rem
      border-bottom: .02rem solid #E5E5E5
      background-color: #F9F9F9
      .lightening
        position: absolute
        top: -1.18rem
        height: 1.18rem
      h2
        vertical-align: center
        line-height: 1.2rem
        font-size: .4rem
        color: #0C0C0C
        text-align: left
        &::before
          content: ""
          position: relative
          top: .04rem
          display: inline-block
          width: .08rem
          height: .4rem
          background-color: #FF7052
          margin-right: .12rem
        span.sub
          position: relative
          top: -.05rem
          display: inline-block
          width: 1.82rem
          height: .5rem
          line-height: .5rem
          background-color: #F3F3F3
          margin: 0 0 0 .2rem
          font-size: .24rem
          color: #9B9B9B
          text-align: center
          -webkit-border-radius: .25rem
          -moz-border-radius: .25rem
          border-radius: .25rem
      .course1
        display: flex
        justify-content: space-between
        margin-bottom: .4rem
        .left
          overflow: hidden
          width: 3.2rem
          height: 3.2rem
          img
            width: 100%
        .right
          position: relative
          width: 3.7rem
          height: 3.2rem
          h4
            overflow: hidden
            /*white-space: nowrap*/
            text-overflow: ellipsis
            font-size: .32rem
            color: #0C0C0C
            font-weight: bold
            text-align: left
          p
            overflow: hidden
            margin: .04rem 0
            /*white-space: nowrap*/
            text-overflow: ellipsis
            color: #9DA4B3
            &.detail
              font-size: .24rem
            &.people
              display: none
              font-size: .22rem
          & > div
            margin: .14rem 0
            span
              display: inline-block
              padding: .02rem .04rem
              border: .01rem solid #FF7052
              margin: 0 .05rem .05rem 0
              font-size: .22rem
              color: #FF7052
              -webkit-border-radius: .04rem
              -moz-border-radius: .04rem
              border-radius: .04rem
          b.price
            position: absolute
            bottom: 0
            left: 0
            display: block
            margin-top: .14rem
            font-size: .3rem
            color: #FF7052
            font-weight: 500
            span
              font-size: .4rem
              font-weight: 600
          a.bmst
            position: absolute
            bottom: 0
            right: 0
            display: block
            width: 1.52rem
            height: .56rem
            line-height: .56rem
            background-color: #FF7052
            font-size: .24rem
            color: #fff
            text-align: center
            -webkit-border-radius: .34rem
            -moz-border-radius: .34rem
            border-radius: .34rem
      .ad
        width: 7.1rem
        height: 1.44rem
        margin: .4rem auto 0
        img
          width: 100%
    .jszg2-banner
      img
        width: 7.5rem
        height: 3.6rem
    #free-listen
      padding: 0 .2rem
      h2
        vertical-align: center
        line-height: 1.2rem
        font-size: .4rem
        color: #0C0C0C
        text-align: left
        &::before
          content: ""
          position: relative
          top: .04rem
          display: inline-block
          width: .08rem
          height: .4rem
          background-color: #FF7052
          margin-right: .12rem
        span.subtitle
          position: relative
          top: -.05rem
          display: inline-block
          height: .5rem
          line-height: .5rem
          padding: 0 .2rem
          background-color: #F3F3F3
          margin: 0 0 0 .2rem
          font-size: .24rem
          color: #9B9B9B
          text-align: center
          -webkit-border-radius: .25rem
          -moz-border-radius: .25rem
          border-radius: .25rem
      .top
        overflow: hidden
        width: 7.1rem
        height: 4.38rem
        margin: 0 auto
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        -webkit-border-top-left-radius: .16rem
        -moz-border-top-left-radius: .16rem
        border-top-left-radius: .16rem
        -webkit-border-top-right-radius: .16rem
        -moz-border-top-right-radius: .16rem
        border-top-right-radius: .16rem
        img
          width: 100%
          height: 100%
      .bottom
        display: flex
        overflow: hidden
        width: 7.1rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        -webkit-border-bottom-left-radius: .16rem
        -moz-border-bottom-left-radius: .16rem
        border-bottom-left-radius: .16rem
        -webkit-border-bottom-right-radius: .16rem
        -moz-border-bottom-right-radius: .16rem
        border-bottom-right-radius: .16rem
        span
          width: 25%
          height: 1.2rem
          line-height: .4rem
          padding: .2rem 0
          background-color: #262D47
          font-size: .28rem
          color: #fff
          text-align: center
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          &.active
            background-color: #FF7052
    .reachbottom
      line-height: 1.5rem
      background-color: #f9f9f9
      font-size: .25rem
      color: #ccc
      letter-spacing: .05rem
      text-align: center
    #fix-bottom-void
      height: 1rem
      background-color: #f9f9f9
      clear: both
</style>



// WEBPACK FOOTER //
// src/components/webs/Jszg.vue